<template>
    <div class="box-bottom">
        <div class="header-box">
            <div class="txt">设备操作</div>
            <div class="btn-switchs">
                <div class="btn-switch-btn" :class="{ 'btn-switch-active': tabIndex == 0 }" @click="changeTab(0)">
                    开关设备
                </div>
                <div class="btn-switch-btn" :class="{ 'btn-switch-active': tabIndex == 1 }" @click="changeTab(1)">
                    行程设备
                </div>
                <div class="bgs" :style="bgsStyle"></div>
            </div>
        </div>
        <div class="content-box" :class="{'content-box-lx':!playIdObj.online}" v-loading="loading">
            <!-- 开关设备 -->
            <div class="content" v-show="tabIndex == 0 && kgsbList.length">
                <div class="item" v-for="(item, index) in kgsbList" :key="index" :class="{
                    marginRight0: (index + 1) % 3 == 0,
                    maginBottom0: threeLie(index, kgsbList),
                    grayscales: !playIdObj.online,
                }">
                    <div class="top-txt">
                        <span v-if="retrunTxt(item.itemList, 'status').dataItemValue == '1'">已打开</span>
                        <span class="red" v-else>已关闭</span>
                        <div class="icon" @click="openKgDrawer(item)"></div>
                    </div>
                    <img src="@/assets/image/product/img_sb_dcf.png" alt="" />
                    <div class="name">{{ item.subDeviceName }}</div>
                </div>
            </div>
            <div class="content-no" v-show="tabIndex == 0 && !kgsbList.length">
                <img src="@/assets/image/home/ZWT.png" alt="" />
                <div class="table-emptyword">暂无数据</div>
            </div>
            <!-- 行程设备 -->
            <div class="content" v-show="tabIndex == 1 && xcsbLsist.length">
                <div class="item" v-for="(item, index) in xcsbLsist" :key="index" :class="{
                    marginRight0: (index + 1) % 3 == 0,
                    maginBottom0: threeLie(index, xcsbLsist),
                    grayscales: !playIdObj.online,
                    'item-animated':
                        retrunTxt(item.itemList, 'status').dataItemValue == '2' ||
                        retrunTxt(item.itemList, 'status').dataItemValue == '1' ||
                        retrunTxt(item.itemList, 'status').dataItemValue == '01' ||
                        retrunTxt(item.itemList, 'status').dataItemValue == '10',
                }">
                    <div class="top-txt">
                        <template v-if="item.init">
                            <template v-if="!backEStop(item)">
                                <span v-if="retrunTxt(item.itemList, 'status').dataItemValue == '0' ||
                    retrunTxt(item.itemList, 'status').dataItemValue == '' || retrunTxt(item.itemList, 'status').dataItemValue == '00' || retrunTxt(item.itemList, 'status').dataItemValue == '4'
                    ">当前位置{{ retrunTxt(item.itemList, 'khd').dataItemValue || 0 }}%</span>
                                <span
                                    v-if="retrunTxt(item.itemList, 'status').dataItemValue == '2' || retrunTxt(item.itemList, 'status').dataItemValue == '10'">下降到{{
                    retrunTxt(item.itemList, 'khd').dataItemValue }}%</span>
                                <span
                                    v-if="retrunTxt(item.itemList, 'status').dataItemValue == '1' || retrunTxt(item.itemList, 'status').dataItemValue == '01'">上升到{{
                    retrunTxt(item.itemList, 'khd').dataItemValue }}%</span>
                            </template>
                            <template v-else>
                                <span class="orange">设备已急停</span>
                            </template>
                        </template>
                        <template v-else>
                            <span class="gray">暂未初始化</span>
                        </template>


                        <div class="icon" @click="openXcDrawer(item)"></div>
                    </div>
                    <img src="@/assets/image/product/img_sb_jl.png" alt="" />
                    <div class="name">{{ item.subDeviceName }}</div>
                </div>
            </div>
            <div class="content-no" v-show="tabIndex == 1 && !xcsbLsist.length">
                <img src="@/assets/image/home/ZWT.png" alt="" />
                <div class="table-emptyword">暂无数据</div>
            </div>
        </div>
        <!-- 全局急停盒子 -->
        <div class="scram-box" v-show="tabIndex == 1 && xcsbLsist.length" :class="{
                    'scram-box-open': scramBtn == false,
                    'scram-box2': scramState,
                }">
            <div class="icon-box">
                <img v-if="scramState" @click="scramClick" src="@/assets/image/product/jiting_2.png" alt="" />
                <img v-else @click="scramClick" src="@/assets/image/product/jiting.png" alt="" />
                <div class="txt">
                    <span v-if="scramState">取消急停</span><span v-else>全局急停</span>
                </div>
            </div>
            <div class="btn-icon" @click="scramBtnClick"></div>
        </div>
        <!-- 信息提示 -->
        <Msg ref="myMsg"></Msg>
        <!-- 开关设备设置抽屉 -->
        <KgSetUp ref="kgSetUp"></KgSetUp>
        <!-- 行程设备设置抽屉 -->
        <XcSetUp ref="XcSetUp"></XcSetUp>
        <!-- 设置安全密码抽屉 -->
        <SetPassword ref="SetPassword"></SetPassword>
    </div>
</template>

<script>
import Msg from "@/components/msg.vue"; //信息提示组件
import KgSetUp from "../components/kgSetUp.vue"; //开关设备设置抽屉
import XcSetUp from "../components/xcSetup-znzd.vue"; //行程设备设置抽屉
import SetPassword from "../components/setPassword.vue";
export default {
    components: { Msg, KgSetUp, XcSetUp, SetPassword },
    props: ['sbAllList', "kgsbList", "xcsbLsist", "safePassword", "playIdObj", "loading", "cgqList", "playIdObjProductType"],
    data() {
        return {
            // 控制是开关设备还是行程设备
            tabIndex: 0,
            // 当前选中的行程设备
            selectxcsb: {},
            // 控制全局急停按钮打开还是关闭
            scramBtn: true,
            // 全局急停按钮状态
            scramState: false,
        }
    },
    watch: {
        // 行程设备列表
        xcsbLsist: {
            handler(newValue,oldValue) {
                let arr = [];
                newValue.forEach((item) => {
                    if (this.retrunTxt(item.itemList, 'e_stop').dataItemValue == "1" || this.retrunTxt(item.itemList, 'status').dataItemValue == '3') {
                        arr.push("true");
                    }
                    let filterArr = oldValue.filter((ele) => {
                        return ele.deviceNum == item.deviceNum && ele.subDeviceNum == item.subDeviceNum
                    })
                    if (filterArr.length) {
                        if (filterArr[0].hasOwnProperty("init")) {
                            item.init = filterArr[0].init
                        } else {
                            item.init = false
                        }
                    } else {
                        item.init = false
                    }
                   
                    this.$http
                        .getAction(
                            this.$api.queryDuration +
                            "?deviceNum=" +
                            this.playIdObj.deviceNum +
                            "&subDeviceNum=" +
                            item.subDeviceNum
                        )
                        .then((res) => {
                            if (res.data) {
                                // 是否设置时长
                                if (this.playIdObjProductType == "1") {//控制箱设备
                                    // 控制箱 总时长如果不为空,表示设置了, 总时长，单次时长，有一个为空，表示未设置
                                    if (
                                        res.data.onTotalDuration == undefined ||
                                        res.data.onceOperationDuration == undefined ||
                                        res.data.onceIntervalDuration == undefined
                                    ) {
                                        // 未设置时长
                                        item.init = false
                                    } else {
                                        // 已经设置时长
                                        item.init = true
                                    }
                                } else {
                                    // 非控制箱,如智能终端  正向总时长和反向总时长都设置了,才算设置,否则未设置
                                    if (res.data.onTotalDuration && res.data.offTotalDuration) {
                                        // 已经设置时长
                                        item.init = true
                                    } else {
                                        // 未设置时长
                                        item.init = false
                                    }
                                }
                                this.$forceUpdate();
                            }
                        })
                });
                if (arr.length == newValue.length) {
                    this.scramState = true;
                } else {
                    this.scramState = false;
                }
            },
            deep: true,
            immediate: true,
        },
    },
    computed: {
        // tab切换的样式
        bgsStyle() {
            let params = {
                left: 0,
            };
            if (this.tabIndex == 0) {
                params = {
                    left: 0,
                };
            } else {
                params = {
                    left: "50%",
                };
            }
            return params;
        },

    },
    methods: {
        // 开关设备行程设备点击切换
        changeTab(index) {
            this.tabIndex = index;
        },
        // 返回状态
        retrunTxt(arr, key) {
            let row = arr.filter((item) => {
                return item.dataItemCode == key;
            });
            if (row.length) {
                return row[0];
            }
            return {};
        },
        // 全局急停按钮点击
        scramClick() {
            // this.xcsbLsist.forEach((item) => {
            //     let info = {};
            //     info.subDeviceNum = item.subDeviceNum;
            //     info.deviceNum = this.playIdObj.deviceNum;
            //     this.scram(this.scramState, info);
            // });
            let info = {};
            info.subDeviceNum = "";
            info.deviceNum = this.playIdObj.deviceNum;
            this.scram(this.scramState, info);
        },
        // 设备急停
        scram(bool, info) {
            let params = {
                deviceNum: info.deviceNum,
                subDeviceNum: info.subDeviceNum,
                stop: bool ? "0" : "1",
                operateSource: "WEB",
            };
            this.$http.postAction(this.$api.scram, params).then((res) => {
                if (res.code == 200 || res.code == 0) {
                    this.scramState = !this.scramState;
                    this.$refs.myMsg.msgShow("设置成功", 1.5);
                } else {
                    this.$refs.myMsg.msgShow(res.msg, 1.5);
                }
            });
        },
        // 全局急停盒子的打开和关闭
        scramBtnClick() {
            this.scramBtn = !this.scramBtn;
        },
        // 判断是否有下编剧
        threeLie(index, list) {
            let len = list.length;
            if (list.length % 3 == 0) {
                if (index == len - 1 || index == len - 2 || index == len - 3) {
                    return true;
                }
            }
            if (list.length % 3 == 1) {
                if (index == len - 1) {
                    return true;
                }
            }
            if (list.length % 3 == 2) {
                if (index == len - 1 || index == len - 2) {
                    return true;
                }
            }
        },
        // 判断是否是急停
        backEStop(item) {
            if (this.retrunTxt(item.itemList, 'e_stop').dataItemValue == '1' ||
                this.retrunTxt(item.itemList, 'status').dataItemValue == '3'
            ) {
                return true
            }
            return false

        },
        // 打开开关设备设置抽屉
        openKgDrawer(item) {
            if (!this.playIdObj.online) {
                this.$refs.myMsg.msgShow("设备已离线", 1.5);
                return;
            }
            this.$refs.kgSetUp.drawer = true;
            let subDeviceNums = [];
            console.log(item);
            // console.log(item.subDeviceNum);
            subDeviceNums.push(item.subDeviceNum);
            let params = {
                subDeviceType: item.subDeviceType,
                subDeviceName: item.subDeviceName,
                subDeviceNums: subDeviceNums,
                deviceNum: this.sbAllList.deviceNum,
                commandsItemList: item.commandsItemList,
                deviceName: this.sbAllList.deviceName,
                dataItemValue: item.itemList[0].dataItemValue,
                deviceId: this.playIdObj.id,
                productType:this.playIdObj.productType
            };
            this.$refs.kgSetUp.equipmentList = this.cgqList;
            if (this.cgqList.length) {
                this.$refs.kgSetUp.automationbjFrom.sensorNum =
                    this.cgqList[0].subDeviceNum;
                this.$refs.kgSetUp.equipmentItems = this.cgqList[0].itemList;
            } else {
                this.$refs.kgSetUp.automationbjFrom.sensorNum = ""
                this.$refs.kgSetUp.equipmentItems = [];
            }


            this.$refs.kgSetUp.infos = params;
            this.$refs.kgSetUp.infosType = "1";
            
            let ps = {
                deviceNum: this.playIdObj.deviceNum,
                subDeviceNum: item.subDeviceNum,
                terminalType:"1"
            }
            this.getquerySubSpace(ps).then((res)=>{
                if (res.data) {
                    this.$refs.kgSetUp.areaName = res.data.terminalAreaFullName
                    this.$forceUpdate()
                }
            })
        },
        // 获取子设备区域信息
        getquerySubSpace(ps) {
            return new Promise((resolve,reject)=>{
                this.$http.postAction(this.$api.querySubSpace,ps).then((res)=>{
                    resolve(res)
                })
            })
            
        },
        // 打开行程设备设置抽屉
        openXcDrawer(item) {
            if (!this.playIdObj.online) {
                this.$refs.myMsg.msgShow("设备已离线", 1.5);
                return;
            }
            // console.log(item);
            this.selectxcsb = item;
            // 判断是否设置了安全密码
            if (this.safePassword) {
                // 时长都已经设置了：进入操作页面
                this.panduanshicStatus();
            } else {
                // 没有设置安全密码
                this.$refs.SetPassword.kzxInfo = this.playIdObj;
                this.$refs.SetPassword.equipmentInfo = this.selectxcsb;
                this.$refs.SetPassword.equipmentType = "2";
                // 打开设置安全密码界面
                this.$refs.SetPassword.drawer = true;
                this.$nextTick(() => {
                    this.$refs.SetPassword.makeFocus();
                });

            }
            let ps = {
                deviceNum: this.playIdObj.deviceNum,
                subDeviceNum: item.subDeviceNum,
                terminalType:"1"
            }
            this.getquerySubSpace(ps).then((res)=>{
                if (res.data) {
                    this.$refs.XcSetUp.areaName = res.data.terminalAreaFullName
                    this.$forceUpdate()
                }
            })
        },
        // 判断设备设置时长状态
        panduanshicStatus() {
            this.$http
                .getAction(
                    this.$api.queryDuration +
                    "?deviceNum=" +
                    this.playIdObj.deviceNum +
                    "&subDeviceNum=" +
                    this.selectxcsb.subDeviceNum
                )
                .then((res) => {
                    if (res.data) {
                        let datas = res.data;
                        // this.$refs.XcSetUp.kzxInfo = this.playIdObj;
                        // this.$refs.XcSetUp.equipmentInfo = this.selectxcsb;
                        // this.$refs.XcSetUp.cgqList = this.cgqList;
                        // this.$refs.XcSetUp.drawer = true;
                        // setTimeout(() => {
                        //     this.$refs.XcSetUp.insideSwitch.timeprotect = true;

                        // }, 0);
                        // return
                        // 是否设置时长
                        if (this.playIdObjProductType == "1") {//控制箱设备
                            // 控制箱 总时长如果不为空,表示设置了, 总时长，单次时长，有一个为空，表示未设置
                            if (
                                res.data.onTotalDuration == undefined ||
                                res.data.onceOperationDuration == undefined ||
                                res.data.onceIntervalDuration == undefined
                            ) {
                                // 未设置时长
                                this.$refs.XcSetUp.kzxInfo = this.playIdObj;
                                this.$refs.XcSetUp.equipmentInfo = this.selectxcsb;
                                this.$refs.XcSetUp.cgqList = this.cgqList;
                                this.$refs.XcSetUp.drawer = true;
                                setTimeout(() => {
                                    this.$refs.XcSetUp.insideSwitch.timeprotect = true;

                                }, 0);
                            } else {
                                // 已经设置时长
                                this.$refs.XcSetUp.kzxInfo = this.playIdObj
                                this.$refs.XcSetUp.equipmentInfo = this.selectxcsb
                                this.$refs.XcSetUp.cgqList = this.cgqList
                                this.$refs.XcSetUp.drawer = true
                                this.$nextTick(() => {
                                    this.$refs.XcSetUp.deviceStatus()
                                    this.$refs.XcSetUp.yuanhuanValue()
                                    this.$refs.XcSetUp.yuanhuanTValue()
                                })
                            }
                        } else {
                            // 非控制箱,如智能终端  正向总时长和反向总时长都设置了,才算设置,否则未设置
                            if (res.data.onTotalDuration && res.data.offTotalDuration) {
                                // 已经设置时长
                                this.$refs.XcSetUp.kzxInfo = this.playIdObj
                                this.$refs.XcSetUp.equipmentInfo = this.selectxcsb
                                this.$refs.XcSetUp.cgqList = this.cgqList
                                this.$refs.XcSetUp.drawer = true
                                this.$nextTick(() => {
                                    this.$refs.XcSetUp.deviceStatus()
                                    this.$refs.XcSetUp.yuanhuanValue()
                                    this.$refs.XcSetUp.yuanhuanTValue()
                                })
                            } else {
                                // 未设置时长
                                this.$refs.XcSetUp.kzxInfo = this.playIdObj;
                                this.$refs.XcSetUp.equipmentInfo = this.selectxcsb;
                                this.$refs.XcSetUp.cgqList = this.cgqList;
                                this.$refs.XcSetUp.drawer = true;
                                setTimeout(() => {
                                    this.$refs.XcSetUp.insideSwitch.timeprotect = true;

                                }, 0);
                            }
                        }
                    }
                });
        },

    },
}
</script>

<style lang="scss" scoped>
.box-bottom {
    position: relative;
    overflow: hidden;


    .header-box {
        height: 0.75rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 0.3rem;
        box-sizing: border-box;
        border-bottom: 1px solid #f1f1f1;

        .txt {
            font-size: 0.225rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #454545;

            img {
                cursor: pointer;
            }
        }

        .btn-switchs {
            text-align: center;
            width: 2.5rem;

            background: #ffffff;
            border: 1px solid #2daea9;
            border-radius: 0.15rem;
            position: relative;

            .btn-switch-btn {
                width: 50%;
                display: inline-block;
                height: 0.45rem;
                line-height: 0.45rem;
                font-size: 0.17rem;
                color: #2daea9;
                position: relative;
                z-index: 5;
                cursor: pointer;
                transition: color 0.5s;
            }

            .btn-switch-active {
                color: #ffffff;
            }

            .bgs {
                width: 50%;
                height: 100%;
                background: #2daea9;
                border-radius: 0.13rem;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 4;
                transition: left 0.5s;
            }
        }
    }

    .content-box {
        height: 85%;
        box-sizing: border-box;
        padding: 0.25rem 0.125rem 0.25rem 0.3rem;

        .content {
            width: 100%;
            height: 100%;
            overflow: auto;
            display: flex;
            flex-wrap: wrap;

            &::-webkit-scrollbar {
                width: 6px;
                height: 0px;
                background-color: transparent;
            }

            &::-webkit-scrollbar-track {
                border-radius: 6px;
                background-color: transparent;
            }

            &::-webkit-scrollbar-thumb {
                border-radius: 6px;
                background-color: rgba(77, 77, 77, 0.2);
            }

            .item {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: center;
                width: 1.8125rem;
                height: 1.675rem;
                background: rgba(231, 241, 243, 0.6);
                border-radius: 0.125rem;
                box-sizing: border-box;
                padding-top: 0.1875rem;
                padding-bottom: 0.1875rem;
                padding-left: 0.2rem;
                padding-right: 0.2125rem;
                margin-bottom: 0.25rem;
                margin-right: 0.3rem;

                .top-txt {
                    width: 115%;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    color: rgba(45, 174, 169, 1);

                    .icon {
                        cursor: pointer;
                        width: 0.2rem;
                        height: 0.2rem;
                        background: url("~@/assets/image/product/shezhi.png") no-repeat;
                    }

                    .red {
                        color: rgba(255, 72, 72, 1);
                    }

                    .orange {
                        color: rgba(245, 110, 30, 1);
                    }
                    .gray {
                        color: #999B9B;
                    }
                }
            }

            .item-animated {
                img {
                    animation: animated-border 2.2s infinite;
                }
            }

            @keyframes animated-border {
                0% {
                    opacity: 1;
                }

                50% {
                    opacity: 0.1;
                }

                100% {
                    opacity: 1;
                }
            }

            .marginRight0 {
                margin-right: 0;
            }

            .maginBottom0 {
                margin-bottom: 0;
            }
        }

        .content-no {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            color: #c8c8c8;

            .table-emptyword {
                margin-top: 0.125rem;
            }
        }
    }
    .content-box-lx {
        .content {
            .item {
                filter: grayscale(100%);
            }
        }
    }

    .scram-box {
        position: absolute;
        bottom: 0.1625rem;
        left: 0;
        width: 1.25rem;
        height: 0.875rem;
        background: #ffffff;
        box-shadow: 2px 0px 10px 0px rgba(5, 83, 80, 0.2);
        border-radius: 0px 0.125rem 0.125rem 0px;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        padding-left: 0.1875rem;
        transition: all 0.5s;
        transform: translateX(-0.925rem);

        .icon-box {

            opacity: 0;
            transition: all 0.5s;

            img {
                cursor: pointer;
            }

            .txt {
                margin-top: 0.1rem;
                font-size: 0.175rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: rgba(245, 110, 30, 1);
            }
        }

        .btn-icon {
            cursor: pointer;
            margin-left: 0.0875rem;
            width: 0.1375rem;
            height: 0.125rem;
            background: url("~@/assets/image/product/shouqi.png") no-repeat;
            transition: all 0.5s;
            transform: rotate(180deg);
        }
    }

    .scram-box2 {
        background: #f56e1e;

        .icon-box {
            .txt {
                margin-top: 0.1rem;
                font-size: 0.175rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: rgba(255, 255, 255, 1);
            }
        }

        .btn-icon {
            background: url("~@/assets/image/product/shouqi2.png") no-repeat;
        }
    }

    .scram-box-open {
        transform: translateX(0);

        .btn-icon {
            transform: rotate(0deg);
        }

        .icon-box {
            opacity: 1;
        }
    }
}
</style>